export default {
  list: [
    "Entertainment",
    "Social",
    "Rating",
    "Blog",
    "Health",
    "Geolocation",
    "POD Management",
    "Tools",
    "Education",
    "Business",
    "Other",
  ],
};
